<app-main-nav>
  <main id="main-content">
    <router-outlet></router-outlet>
  </main>
</app-main-nav>
